import * as React from "react";

import { Portal, UsePortalDropzone } from "../../Common";

import { useMyBagPresentationModel } from "../providers";

import { ApplyACoupon } from "../apply-a-coupon";
import { ApplyAGiftCard } from "../apply-a-giftcard";
import { AppliedAGiftCards } from '../apply-a-giftcard/applied-giftcards';

enum AppliableOptions {
  None = "none",
  Giftcard = "giftcard",
  Coupon = "coupon",
}

export const MAX_GIFT_CARDS = 5;

export const GiftcardsAndPromotions: React.FunctionComponent = () => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();

  const [userWantsToApplyOption, setUserWantsToApplyOption] = React.useState(
    AppliableOptions.None
  );

  const myAppliedGiftcard = React.useMemo(() => {
    return presentationMyBagOrder?.giftCardValueBreakdown;
  }, [presentationMyBagOrder]);
  const isThereAPromoCodeApplied = React.useMemo(() => {
    return !!presentationMyBagOrder?.promoCodeBreakdown || false;
  }, [presentationMyBagOrder]);
 const isMaxGCApplied = React.useMemo(() => {
    return (presentationMyBagOrder?.giftCardValueBreakdown || []).length >= MAX_GIFT_CARDS;
  }, [presentationMyBagOrder]);

  const handleApplyAGiftcard: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(() => {
      if (userWantsToApplyOption !== AppliableOptions.Giftcard) {
        setUserWantsToApplyOption(AppliableOptions.Giftcard);
      } else {
        setUserWantsToApplyOption(AppliableOptions.None);
      }
    }, [userWantsToApplyOption, setUserWantsToApplyOption]);

  const handleApplyAPromoCode: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(() => {
      if (userWantsToApplyOption !== AppliableOptions.Coupon) {
        setUserWantsToApplyOption(AppliableOptions.Coupon);
      } else {
        setUserWantsToApplyOption(AppliableOptions.None);
      }
    }, [userWantsToApplyOption, setUserWantsToApplyOption]);

  if (presentationMyBagOrder?.isThisAVirtualOrder) {
    return null;
  }

  return (
    <Portal
      selector={`
        .legacy-magento-checkout-container 
        > .legacy-magento-checkout-container-page-contents-container
        > .legacy-magento-checkout-container-direct-container
      `}
      dropzone={UsePortalDropzone.BeforeFirstChild}
      dontCreateRootElementWhenNone={true}
      portalStagingNodeClassName="legacy-magento-checkout-container--portal-giftcards-and-promotions"
    >
      <section className="giftcards-and-promotions">
        <h2>{`Gift Cards & Promotions`}</h2>
          <div className="apply-options">
            {!isMaxGCApplied && <button
              className={`apply-a-giftcard ${
                userWantsToApplyOption === AppliableOptions.Giftcard
                  ? "active"
                  : "inactive"
              }`}
              onClick={handleApplyAGiftcard}
            >{`Apply a Gift Card`}</button>}
            {!isThereAPromoCodeApplied && (<button
              className={`apply-a-promo-code ${
                userWantsToApplyOption === AppliableOptions.Coupon
                  ? "active"
                  : "inactive"
              }`}
              onClick={handleApplyAPromoCode}
            >{`Apply a Promo Code`}</button>)}
          </div>
        <div className="apply-details-container">
          {!isMaxGCApplied && (myAppliedGiftcard ||
          userWantsToApplyOption === AppliableOptions.Giftcard) ? (
            <ApplyAGiftCard showForm={ userWantsToApplyOption === AppliableOptions.Giftcard}/>
          ) : null}
          {isThereAPromoCodeApplied ||
          userWantsToApplyOption === AppliableOptions.Coupon ? (
            <ApplyACoupon />
          ) : null}
          <AppliedAGiftCards />
        </div>
      </section>
    </Portal>
  );
};
